export type TaskTableRow = Record<string, string | number | boolean | null>;

export const SEARCHABLE_COLUMNS = new Set([
  "task_id",
  "task_title",
  "issue_id",
  "signal",
  "risk",
  "assigned_role",
  "priority",
  "status",
]);

export const FIXED_COLUMNS = new Set(["task_id"]);

export const HIDDEN_COLUMNS = new Set<string>(["description", "comments"]);

export const TASK_COLUMN_ORDER = [
  "task_id",
  "task_title",
  "issue_id",
  "signal",
  "risk",
  "assigned_role",
  "priority",
  "due_date",
  "status",
] as const;

export const TITLE_MAPPING = {
  task_id: "Task ID",
  task_title: "Task Title",
  issue_id: "Breach ID",
  signal: "Signal",
  risk: "Risk",
  description: "Description",
  assigned_role: "Assigned To",
  priority: "Priority",
  due_date: "Due Date",
  status: "Status",
  comments: "Comments",
} satisfies Record<string, string>;

export const COLUMN_WIDTHS = {
  DEFAULT: 160,
  task_id: 120,
  task_title: 360,
  issue_id: 120,
  signal: 260,
  risk: 140,
  description: 420,
  assigned_role: 220,
  priority: 140,
  due_date: 160,
  status: 140,
  comments: 320,
} satisfies Record<string, number>;
